// Generated by genversion.
export const version = '2.24.0';
